import React from 'react'
import "./App.css"
import { Header } from "./components/HomePage/Header"
import { Footer } from "./components/HomePage/Footer"
import { GalleryPage } from "./components/GalleryPage/GalleryPage"
import { YoutubeGalleryPage } from "./components/GalleryPage/YoutubeGalleryPage/YoutubeGalleryPage"
import { FacebookGalleryPage } from "./components/GalleryPage/FacebookGalleryPage/FacebookGalleryPage"
import { AboutPage } from "./components/AboutPage/AboutPage"
import { ContactPage } from "./components/ContactPage/ContactPage"
import { HomePage } from "./components/HomePage/HomePage/HomePage"
import {
    BrowserRouter as Router,
    Route,
    Switch
} from "react-router-dom";

const App = () => {
    return (
        <Router>
         <div className="AppContainer">
        <Switch>
        
           <Route exact path="/">
            <Header />
            <HomePage />
            <Footer />
           </Route>

           <Route path="/gallery">
            <Header />
            <GalleryPage />
            <Footer />
           </Route>

           <Route path="/g/youtube">
           <Header />
           <YoutubeGalleryPage />
           <Footer />
           </Route>

           <Route path="/g/facebook">
            <Header />
            <FacebookGalleryPage />
            <Footer />
           </Route>

           <Route path="/about">
            <Header />
            <AboutPage />
            <Footer />
           </Route>

           <Route path="/contact_us">
            <Header />
            <ContactPage />
            <Footer />
           </Route>

        </Switch>
         </div>
        </Router>
    )
}

export default App